//import Libraries
import React, { Component } from 'react';
import {connect} from 'react-redux'
import {storageRef} from '../../../../firebase';
import * as axios from 'axios'
//import Components
import {Row, Col, Button, Collapse, FormGroup, Label} from 'reactstrap'; 
import ArticleInputFormGroup from './Elements/ArticleInputFormGroup';
import QuillEditor from '../../Components/QuillEditor/QuillEditor';
import ArticleDateFormGroup from './Elements/ArticleDateFormGroup';
import ArticleSelectFormGroup from './Elements/ArticleSelectFormGroup';

import EditConfirmButton from '../../Components/EditConfirmButton/EditConfirmButton';

import * as homepageActions from '../actions/homepageActions';
import * as dateUtils from './Utils/dateUtils';
import * as htmlActions from '../../actions/htmlActions';

//import Styles
import './Article.css'

class Article extends Component {

    constructor(props) {
        const {article} = props;

        const today = new Date();
        const dd = today.getDate();
        const mm = today.getMonth()+1; //January is 0!
        const yyyy = today.getFullYear();

        super(props);
        this.state = {
            title : article.title,
            subTitle : article.subTitle,
            category : article.category,
            text : '불러오는 중입니다...',
            imageCount : article.imageCount,
            date : article.date,
            shouldDeletes : []
        }
    }

    toggleCollapse = () => {
        const {article} = this.props;
        this.props.askCancleEditing(() => {
            this.props.toggleEditing(article.id);
            this.setState(prevState => ({
                title: article.title,
                subTitle: article.subTitle,
                imageCount : article.imageCount,
                text: '',
                shouldDeletes : []
            }))
        }, article.id)
    }

    addShouldDeletes = (id) => {
        let shouldDeletes = [...this.state.shouldDeletes];
        if(shouldDeletes.indexOf(id) === -1){
            shouldDeletes.push(id);
            this.setState(prevState => ({
                shouldDeletes,
                imageCount : prevState.imageCount - 1
            }))
        }
    }
    removeShouldDeletes =  (id) => {
        let shouldDeletes = [...this.state.shouldDeletes]; 
        const index = shouldDeletes.indexOf(id);
        if(index !== -1) {
            shouldDeletes.splice(index, 1);    
            this.setState(prevState => ({
                shouldDeletes,
                imageCount : prevState.imageCount + 1
            }))
        }
    }

    handleOnChange = (e) => {
        this.setState({
            [e.target.name] : e.target.value
        })
    }
    handleQuillChange=(value) => {
        this.setState({ text: value })
    }
    setImageCount = (value) => {
        this.setState({
            imageCount : value
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(!prevProps.editing && this.props.editing) {
            this.loadText()
        }
    }

    loadText = () => {
        const articleRef = storageRef.child(`articles/${this.props.article.id}.html`);
        articleRef.getDownloadURL()
            .then((url) => {
                axios.get(url, {
                })
                    .then((res) => {
                        this.setState({
                            text : res.data
                        })
                    })
                    .catch((e)=>{
                    })
            })
            .catch((e) => {
            })
    }

    canRegisterArticle = ()=> {
        return (
            this.state.title !== '' &&
            this.state.subTitle !== '' && 
            this.state.text !== ''  && 
            dateUtils.validateDate(this.state.date)
        )
    }

    render() {
        const canRegister = this.canRegisterArticle();

        const {article, editing} = this.props;

        const renderNotEditing = (
            <Row>
                <div style={{width: "30px"}}className="IndexLabel">{this.props.index}</div>
                <Col xs={1}>
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                        <Label className="mr-sm-2"><b>카테고리</b></Label>
                        <p>{article.category}</p> 
                    </FormGroup>
                </Col>
                <Col xs={3}>
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                        <Label className="mr-sm-2"><b>제목</b></Label>
                        <p>{article.title}</p> 
                    </FormGroup>
                </Col>
                <Col xs={3}>
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                        <Label className="mr-sm-2"><b>소제목</b></Label>
                        <p>{article.subTitle}</p> 
                    </FormGroup>
                </Col>
                <Col xs={2}>
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                        <Label className="mr-sm-2"><b>날짜</b></Label>
                        <p>{article.date}</p> 
                    </FormGroup>
                </Col>
                <Col xs={1}>
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                        <Label className="mr-sm-2"><b>조회수</b></Label>
                        <p>{article.view}</p> 
                    </FormGroup>
                </Col>
                <Col xs={1}>
                    <EditConfirmButton 
                        editing={editing}
                        onToggleEditing={this.toggleCollapse}
                        onConfirm={() => {
                            const { category, title, subTitle, text, imageCount, date } = this.state;
                            this.props.onUpdateArticle({
                                id : article.id,
                                category,
                                title,
                                subTitle,
                                text,
                                imageCount,
                                date
                            });
                            this.props.onDeleteUnusedImages("article_images", article.id, this.state.shouldDeletes);
                            this.toggleCollapse();
                        }}
                        onRemove={() => this.props.onDeleteArticle(this.props.article.id, this.props.article.imageCount)}
                    />
                </Col>
            </Row>
        );

        const renderEditing = (
            <Collapse isOpen={editing}>
                <div className="IndexLabel">{this.props.index}</div>
                <ArticleSelectFormGroup
                    label="분류"
                    name="category"
                    value={this.state.category}
                    onChange={this.handleOnChange}
                    options={["대영소식", "자료실"]}
                    values={["news", "reference"]}
                    disabled={editing}
                />
                <ArticleDateFormGroup
                    label="날짜"
                    type="text"
                    name="date"
                    maxlength="10"
                    value={this.state.date}
                    onChange={this.handleOnChange}
                    disabled={editing}
                />
                <ArticleInputFormGroup
                    label="제목"
                    type="text"
                    name="title"
                    value={this.state.title}
                    onChange={this.handleOnChange}
                    disabled={editing}
                />
                <ArticleInputFormGroup
                    label="소제목"
                    type="text"
                    name="subTitle"
                    value={this.state.subTitle}
                    onChange={this.handleOnChange}
                    disabled={editing}
                />
                <QuillEditor 
                    addShouldDeletes={this.addShouldDeletes}
                    removeShouldDeletes={this.removeShouldDeletes}
                    imageStoragePath = "article_images"
                    id={this.props.article.id}
                    imageCount={this.state.imageCount}
                    setImageCount={this.setImageCount}
                    label="내용"
                    name="text"
                    value={this.state.text}
                    onChange={this.handleQuillChange}
                    disabled={editing}
                />
                <EditConfirmButton
                    editing={editing}
                    onToggleEditing={this.toggleCollapse}
                    onConfirm={() => {
                        const { category, title, subTitle, text, imageCount, date } = this.state;
                        this.props.onUpdateArticle({
                            id : article.id,
                            category,
                            title,
                            subTitle,
                            text,
                            imageCount,
                            date
                        });
                        this.props.onDeleteUnusedImages("article_images", article.id, this.state.shouldDeletes);
                        this.toggleCollapse();
                    }}
                    onRemove={() => this.props.onDeleteArticle(this.props.article.id, this.props.article.imageCount)}
                />
            </Collapse>
        );
        return (
            <div className="sub-category">
            {
                editing ? renderEditing : renderNotEditing
            }
            </div>
        );
    }
}

const mapStateToProps =(state) => {
    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onDeleteUnusedImages : (storagePath, id, imageIds) => {
            dispatch(homepageActions.deleteUnusedImages(storagePath, id, imageIds));
        },
        onUpdateArticle : (datas) => {
            dispatch(homepageActions.updateArticle(datas));
        },
        onDeleteArticle : (id, imageCount) => {
            dispatch(homepageActions.deleteArticle(id, imageCount));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Article);


// WEBPACK FOOTER //
// ./src/pages/Admin/HomepageManager/ArticleManager/Article.js